import React, { useState } from "react";
import {
  Box,
  FormLabel,
  List,
  ListItem,
  ListItemText,
  Typography,
  Button,
  Collapse,
} from "@mui/material";

const FiltersStep = ({ filterModel, selectedIds }) => {
  const hasFilters = filterModel?.items?.length > 0;
  const hasIds = selectedIds?.length > 0;

  const showOnlyIds = hasFilters && hasIds;
  const showOnlyFilters = hasFilters && !hasIds;
  const showOnlySelectedIds = !hasFilters && hasIds;

  const [showAllIds, setShowAllIds] = useState(false);

  return (
    <Box>
      {showOnlyFilters && (
        <>
          <FormLabel component="legend" sx={{ mb: 1 }}>
            These filters will be used to find recorded calls:
          </FormLabel>
          <List>
            {filterModel.items.map((filter, index) => (
              <ListItem key={index}>
                <ListItemText
                  primary={`${filter.columnField || filter.field} ${
                    filter.operatorValue || filter.operator
                  } ${filter.value}`}
                />
              </ListItem>
            ))}
          </List>
        </>
      )}

      {(showOnlyIds || showOnlySelectedIds) && (
        <>
          <FormLabel component="legend" sx={{ mb: 1 }}>
            Selected Recorded Call IDs:
          </FormLabel>

          <Typography variant="body2" sx={{ mb: 1 }}>
            {selectedIds.length} recorded calls selected.
          </Typography>

          {selectedIds.length > 10 && (
            <Button
              onClick={() => setShowAllIds(!showAllIds)}
              size="small"
              variant="outlined"
              sx={{ mb: 1 }}
            >
              {showAllIds ? "Hide List" : "Show All"}
            </Button>
          )}

          <Collapse in={showAllIds || selectedIds.length <= 10}>
            <Box
              sx={{
                maxHeight: 200,
                overflowY: "auto",
                border: "1px solid #ddd",
                borderRadius: 1,
              }}
            >
              <List dense>
                {selectedIds.map((id, index) => (
                  <ListItem key={index}>
                    <ListItemText primary={`Call ID: ${id}`} />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Collapse>
        </>
      )}

      {!hasFilters && !hasIds && (
        <Typography color="error">No filters or IDs selected.</Typography>
      )}
    </Box>
  );
};

export default FiltersStep;
